import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import CTDialog from 'components/CTDialog';

//import globalStyle from 'styles/GlobalStyle';
import { TableHeaderCell, TableCellContent, ActionIconButton } from 'styles/GlobalStyle';

//const useStyles = globalStyle;

const TenantTable = ({ className, isAdmin, tableData, dataType, tableHeader, actionButtonSelection, fnOnViewDetailHandler, fnOnPaymentHandler, fnOnRevertPayHandler, ...rest }) => {

  //const classes = useStyles();
  const [selectedItem, setSelectedItem] = useState(null);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [isDeleteDialogOpen, toggleDeleteDialog] = React.useState(false);  

  const handleClick = (event, data) => {
    setSelectedItem(data);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setSelectedItem(null);
    setAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const start = page * rowsPerPage;
  const end = start + rowsPerPage;

  return (
    <>
      <RootContainer className={className}
        {...rest}>
        <PerfectScrollbar>
          <Box minWidth={1050}>
            <Table size="small">
              <TableHeader>
                <TableRow>
                  {tableHeader.map(header => (
                    <TableHeaderCell key={header.id}>
                      {header.label}
                    </TableHeaderCell>
                  ))
                  }
                </TableRow>
              </TableHeader>
              <TableBody>
                {tableData.slice(start, end).map((data) => (
                  <TableRow
                    hover
                    key={data.tenantId}
                  >
                    <TableCellContent>
                      {data.tenantId}
                    </TableCellContent>
                    <TableCellContent>
                      {data.company}
                    </TableCellContent>
                    <TableCellContent>
                      {data.email}
                    </TableCellContent>
                    <TableCellContent>
                      {data.state}
                    </TableCellContent>
                    <TableCellContent>
                      {data.country}
                    </TableCellContent>
                    <TableCellContent>
                      {data.accountPlan}
                    </TableCellContent>
                    <TableCellContent>
                      {data.registrationDate}
                    </TableCellContent>
                    <TableCellContent>
                      {data.lastPaidDate}
                    </TableCellContent>
                    <TableCellContent>
                      {data.nextPaymentDate}
                    </TableCellContent>
                    <TableCellContent>
                      {data.status}
                    </TableCellContent>
                    <TableCellContent>
                      {data.tenantSetting.totalOrderCount}
                    </TableCellContent>
                    <TableCellContent>
                      {data.tenantSetting.maxOrderCount}
                    </TableCellContent>                                        
                    {actionButtonSelection && <TableCellContent>
                      <ActionIconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={(evt) => handleClick(evt, data)}
                        size="large">
                        <MoreVertIcon />
                      </ActionIconButton>
                      <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={handleClose}
                        //TBC Ravi
                        /*
                        PaperProps={{
                          className: classes.popoverMenuStyle //TBC
                        }}
                        */
                      >
                        <MenuItem key="edit" onClick={() => fnOnViewDetailHandler(selectedItem)}><EditOutlinedIcon fontSize="small" color='primary' />&nbsp;&nbsp;View Detail</MenuItem>
                        <Divider />
                        <MenuItem key="delete" onClick={() => fnOnPaymentHandler(selectedItem)}><PaymentOutlinedIcon fontSize="small" color='primary' />&nbsp;&nbsp;Make Payment</MenuItem>
                        <Divider />
                        <MenuItem key="reset" disabled={!isAdmin} onClick={() => togglePasswordResetDialog(true)}><LockOutlinedIcon fontSize="small" color='primary' />&nbsp;&nbsp;Password Reset</MenuItem>
                      </Menu>
                    </TableCellContent>}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
        <TablePagination
          component="div"
          count={tableData.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[15, 25, 50, 100]}
        />
      </RootContainer>
      <CTDialog
        open={isDeleteDialogOpen}
        title={<Typography variant="h5">Delete Tenant</Typography>}
        content={<Typography variant="h5">Do you want to delete Tenant {selectedItem && selectedItem.name} ?</Typography>}
        action={<React.Fragment>
          <Button color="primary" onClick={() => fnOnDeleteRowHandler(selectedItem)}>Delete</Button>
          <Button color="primary" onClick={() => toggleDeleteDialog(false)}>Cancel</Button>
        </React.Fragment>
        }
      />
    </>
  );
};

TenantTable.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
  actionButtonSelection: PropTypes.bool
};

export default TenantTable;